import { render, staticRenderFns } from "./OstanRequest.vue?vue&type=template&id=2537c790&scoped=true"
import script from "./OstanRequest.vue?vue&type=script&lang=js"
export * from "./OstanRequest.vue?vue&type=script&lang=js"
import style0 from "./OstanRequest.vue?vue&type=style&index=0&id=2537c790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537c790",
  null
  
)

export default component.exports